<template>
  <div class="demo-alignment">
    <location-filter v-on:updated="locationChanged" />
    <date-slider-filter v-on:updated="periodChanged" />
  </div>
</template>

<script>
import LocationFilter from '@/components/filters/LocationFilter'
import DateSliderFilter from '@/components/filters/DateSliderFilter'

export default {
  name: 'ChartFilter',
  components: {
    LocationFilter,
    DateSliderFilter
  },
  data: () => ({
    country: 'Ghana',
    region: 'All',
    town: 'All',
    start: '2020-03-01',
    end: new Date().toISOString().slice(0, 10)
  }),
  created() {},
  methods: {
    locationChanged(args) {
      this.country = args.country
      this.region = args.region
      this.town = args.town
      this.sendUpdate()
    },
    periodChanged(args) {
      this.start = args.start
      this.end = args.end
      this.sendUpdate()
    },
    sendUpdate() {
      this.$emit('updated', {
        country: this.country,
        region: this.region,
        town: this.town,
        start: this.start,
        end: this.end
      })
    }
  }
}
</script>

<style></style>
